import { render, staticRenderFns } from "./AiCourseBuilder.vue?vue&type=template&id=11899af3&scoped=true"
import script from "./AiCourseBuilder.vue?vue&type=script&lang=js"
export * from "./AiCourseBuilder.vue?vue&type=script&lang=js"
import style0 from "./AiCourseBuilder.vue?vue&type=style&index=0&id=11899af3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11899af3",
  null
  
)

export default component.exports